import { render } from "./MainHeaderLogo.vue?vue&type=template&id=572a0981&scoped=true"
import script from "./MainHeaderLogo.vue?vue&type=script&lang=js"
export * from "./MainHeaderLogo.vue?vue&type=script&lang=js"

import "./MainHeaderLogo.vue?vue&type=style&index=0&id=572a0981&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572a0981"]])

export default __exports__